import ColumnsContent from 'components/Hocs/ColumnsContent';
import RoomsList from './RoomsList';
import RoomsListRightSidebar from './RoomsListRightSidebar';

export default ColumnsContent(RoomsList, RoomsListRightSidebar);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/MyMessages/RoomsList/index.js